import { DependencyList, useLayoutEffect, useRef } from 'react';

export const useEffectOnChange = (callback: () => void, deps: DependencyList) => {
  const firstRun = useRef<boolean>(true);

  useLayoutEffect(() => {
    if (firstRun.current) {
      firstRun.current = false;
      return;
    }
    callback();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
